// extracted by mini-css-extract-plugin
export default {"section":"style_section__YOBPZ","content":"style_content__Hk4Vi","sectionContainer":"style_sectionContainer__J8ceQ"};